/** Countries with flag icons for travel-tag picker (geo_countries ∩ country-flag-icons). */

export type FlagCountry = {
  code: string;
  ru: string;
  en: string;
};

export const FLAG_COUNTRIES: FlagCountry[] = [
  { code: 'RU', ru: "Российская Федерация", en: "Russian Federation" },
  { code: 'BY', ru: "Беларусь", en: "Belarus" },
  { code: 'KZ', ru: "Казахстан", en: "Kazakhstan" },
  { code: 'UA', ru: "Украина", en: "Ukraine" },
  { code: 'AM', ru: "Армения", en: "Armenia" },
  { code: 'GE', ru: "Грузия", en: "Georgia" },
  { code: 'UZ', ru: "Узбекистан", en: "Uzbekistan" },
  { code: 'US', ru: "США", en: "United States of America" },
  { code: 'GB', ru: "Великобритания", en: "United Kingdom" },
  { code: 'DE', ru: "Германия", en: "Germany" },
  { code: 'FR', ru: "Франция", en: "France" },
  { code: 'IT', ru: "Италия", en: "Italy" },
  { code: 'ES', ru: "Испания", en: "Spain" },
  { code: 'TR', ru: "Турция", en: "Türkiye" },
  { code: 'TH', ru: "Таиланд", en: "Thailand" },
  { code: 'CN', ru: "КНР (Китайская Народная Республика)", en: "People's Republic of China" },
  { code: 'JP', ru: "Япония", en: "Japan" },
  { code: 'AE', ru: "ОАЭ", en: "United Arab Emirates" },
  { code: 'BR', ru: "Бразилия", en: "Brazil" },
  { code: 'AR', ru: "Аргентина", en: "Argentina" },
  { code: 'UY', ru: "Уругвай", en: "Uruguay" },
  { code: 'CL', ru: "Чили", en: "Chile" },
  { code: 'MX', ru: "Мексика", en: "Mexico" },
  { code: 'EG', ru: "Египет", en: "Egypt" },
  { code: 'PE', ru: "Перу", en: "Peru" },
  { code: 'CO', ru: "Колумбия", en: "Colombia" },
  { code: 'AF', ru: "Афганистан", en: "Afghanistan" },
  { code: 'AX', ru: "Аландские острова", en: "Åland Islands" },
  { code: 'AL', ru: "Албания", en: "Albania" },
  { code: 'DZ', ru: "Алжир", en: "Algeria" },
  { code: 'AS', ru: "Американское Самоа", en: "American Samoa" },
  { code: 'AD', ru: "Андорра", en: "Andorra" },
  { code: 'AO', ru: "Ангола", en: "Angola" },
  { code: 'AI', ru: "Ангилья", en: "Anguilla" },
  { code: 'AQ', ru: "Антарктида", en: "Antarctica" },
  { code: 'AG', ru: "Антигуа и Барбуда", en: "Antigua and Barbuda" },
  { code: 'AW', ru: "Аруба", en: "Aruba" },
  { code: 'AU', ru: "Австралия", en: "Australia" },
  { code: 'AT', ru: "Австрия", en: "Austria" },
  { code: 'AZ', ru: "Азербайджан", en: "Azerbaijan" },
  { code: 'BS', ru: "Багамы", en: "Bahamas" },
  { code: 'BH', ru: "Бахрейн", en: "Bahrain" },
  { code: 'BD', ru: "Бангладеш", en: "Bangladesh" },
  { code: 'BB', ru: "Барбадос", en: "Barbados" },
  { code: 'BE', ru: "Бельгия", en: "Belgium" },
  { code: 'BZ', ru: "Белиз", en: "Belize" },
  { code: 'BJ', ru: "Бенин", en: "Benin" },
  { code: 'BM', ru: "Бермудские острова", en: "Bermuda" },
  { code: 'BT', ru: "Бутан", en: "Bhutan" },
  { code: 'BO', ru: "Боливия", en: "Bolivia" },
  { code: 'BA', ru: "Босния и Герцеговина", en: "Bosnia and Herzegovina" },
  { code: 'BW', ru: "Ботсвана", en: "Botswana" },
  { code: 'BV', ru: "Остров Буве", en: "Bouvet Island" },
  { code: 'IO', ru: "Британская территория в Индийском океане", en: "British Indian Ocean Territory" },
  { code: 'VG', ru: "Британские Виргинские острова", en: "British Virgin Islands" },
  { code: 'BN', ru: "Бруней", en: "Brunei Darussalam" },
  { code: 'BG', ru: "Болгария", en: "Bulgaria" },
  { code: 'BF', ru: "Буркина-Фасо", en: "Burkina Faso" },
  { code: 'BI', ru: "Бурунди", en: "Burundi" },
  { code: 'KH', ru: "Камбоджа", en: "Cambodia" },
  { code: 'CM', ru: "Камерун", en: "Cameroon" },
  { code: 'CA', ru: "Канада", en: "Canada" },
  { code: 'CV', ru: "Кабо-Верде", en: "Cape Verde" },
  { code: 'KY', ru: "Каймановы острова", en: "Cayman Islands" },
  { code: 'CF', ru: "ЦАР", en: "Central African Republic" },
  { code: 'TD', ru: "Чад", en: "Chad" },
  { code: 'CX', ru: "Остров Рождества", en: "Christmas Island" },
  { code: 'CC', ru: "Кокосовые острова", en: "Cocos (Keeling) Islands" },
  { code: 'KM', ru: "Коморы", en: "Comoros" },
  { code: 'CK', ru: "Острова Кука", en: "Cook Islands" },
  { code: 'CR', ru: "Коста-Рика", en: "Costa Rica" },
  { code: 'CI', ru: "Кот-д’Ивуар", en: "Cote d'Ivoire" },
  { code: 'XC', ru: "Крым", en: "Crimea" },
  { code: 'HR', ru: "Хорватия", en: "Croatia" },
  { code: 'CU', ru: "Куба", en: "Cuba" },
  { code: 'CW', ru: "Кюрасао", en: "Curaçao" },
  { code: 'CY', ru: "Кипр", en: "Cyprus" },
  { code: 'CZ', ru: "Чехия", en: "Czech Republic" },
  { code: 'CD', ru: "Демократическая Республика Конго", en: "Democratic Republic of the Congo" },
  { code: 'DK', ru: "Дания", en: "Denmark" },
  { code: 'DJ', ru: "Джибути", en: "Djibouti" },
  { code: 'DM', ru: "Доминика", en: "Dominica" },
  { code: 'DO', ru: "Доминиканская Республика", en: "Dominican Republic" },
  { code: 'EC', ru: "Эквадор", en: "Ecuador" },
  { code: 'SV', ru: "Сальвадор", en: "El Salvador" },
  { code: 'GQ', ru: "Экваториальная Гвинея", en: "Equatorial Guinea" },
  { code: 'ER', ru: "Эритрея", en: "Eritrea" },
  { code: 'EE', ru: "Эстония", en: "Estonia" },
  { code: 'SZ', ru: "Эсватини", en: "Eswatini" },
  { code: 'ET', ru: "Эфиопия", en: "Ethiopia" },
  { code: 'FK', ru: "Фолклендские острова", en: "Falkland Islands" },
  { code: 'FO', ru: "Фарерские острова", en: "Faroe Islands" },
  { code: 'FM', ru: "Федеративные Штаты Микронезии", en: "Federated States of Micronesia" },
  { code: 'FJ', ru: "Фиджи", en: "Fiji" },
  { code: 'FI', ru: "Финляндия", en: "Finland" },
  { code: 'GF', ru: "Французская Гвиана", en: "French Guiana" },
  { code: 'PF', ru: "Французская Полинезия", en: "French Polynesia" },
  { code: 'TF', ru: "Французские Южные и Антарктические территории", en: "French Southern and Antarctic Lands" },
  { code: 'GA', ru: "Габон", en: "Gabon" },
  { code: 'GH', ru: "Гана", en: "Ghana" },
  { code: 'GI', ru: "Гибралтар", en: "Gibraltar" },
  { code: 'GR', ru: "Греция", en: "Greece" },
  { code: 'GL', ru: "Гренландия", en: "Greenland" },
  { code: 'GD', ru: "Гренада", en: "Grenada" },
  { code: 'GP', ru: "Гваделупа", en: "Guadeloupe" },
  { code: 'GU', ru: "Гуам", en: "Guam" },
  { code: 'GT', ru: "Гватемала", en: "Guatemala" },
  { code: 'GG', ru: "Гернси", en: "Guernsey" },
  { code: 'GN', ru: "Гвинея", en: "Guinea" },
  { code: 'GW', ru: "Гвинея-Бисау", en: "Guinea-Bissau" },
  { code: 'GY', ru: "Гайана", en: "Guyana" },
  { code: 'HT', ru: "Гаити", en: "Haiti" },
  { code: 'HM', ru: "Остров Херд и острова Макдональд", en: "Heard Island and McDonald Islands" },
  { code: 'HN', ru: "Гондурас", en: "Honduras" },
  { code: 'HK', ru: "Гонконг", en: "Hong Kong" },
  { code: 'HU', ru: "Венгрия", en: "Hungary" },
  { code: 'IS', ru: "Исландия", en: "Iceland" },
  { code: 'IN', ru: "Индия", en: "India" },
  { code: 'ID', ru: "Индонезия", en: "Indonesia" },
  { code: 'IQ', ru: "Ирак", en: "Iraq" },
  { code: 'IE', ru: "Ирландия", en: "Ireland" },
  { code: 'IR', ru: "Иран", en: "Islamic Republic of Iran" },
  { code: 'IM', ru: "Остров Мэн", en: "Isle of Man" },
  { code: 'IL', ru: "Израиль", en: "Israel" },
  { code: 'JM', ru: "Ямайка", en: "Jamaica" },
  { code: 'JE', ru: "Джерси", en: "Jersey" },
  { code: 'JO', ru: "Иордания", en: "Jordan" },
  { code: 'KE', ru: "Кения", en: "Kenya" },
  { code: 'KI', ru: "Кирибати", en: "Kiribati" },
  { code: 'XK', ru: "Косово", en: "Kosovo" },
  { code: 'KW', ru: "Кувейт", en: "Kuwait" },
  { code: 'KG', ru: "Киргизия", en: "Kyrgyzstan" },
  { code: 'LA', ru: "Лаос", en: "Lao People's Democratic Republic" },
  { code: 'LV', ru: "Латвия", en: "Latvia" },
  { code: 'LB', ru: "Ливан", en: "Lebanon" },
  { code: 'LS', ru: "Лесото", en: "Lesotho" },
  { code: 'LR', ru: "Либерия", en: "Liberia" },
  { code: 'LY', ru: "Ливия", en: "Libya" },
  { code: 'LI', ru: "Лихтенштейн", en: "Liechtenstein" },
  { code: 'LT', ru: "Литва", en: "Lithuania" },
  { code: 'LU', ru: "Люксембург", en: "Luxembourg" },
  { code: 'MO', ru: "Макао", en: "Macao" },
  { code: 'MG', ru: "Мадагаскар", en: "Madagascar" },
  { code: 'MW', ru: "Малави", en: "Malawi" },
  { code: 'MY', ru: "Малайзия", en: "Malaysia" },
  { code: 'MV', ru: "Мальдивы", en: "Maldives" },
  { code: 'ML', ru: "Мали", en: "Mali" },
  { code: 'MT', ru: "Мальта", en: "Malta" },
  { code: 'MH', ru: "Маршалловы Острова", en: "Marshall Islands" },
  { code: 'MQ', ru: "Мартиника", en: "Martinique" },
  { code: 'MR', ru: "Мавритания", en: "Mauritania" },
  { code: 'MU', ru: "Маврикий", en: "Mauritius" },
  { code: 'YT', ru: "Майотта", en: "Mayotte" },
  { code: 'MD', ru: "Молдавия", en: "Moldova, Republic of" },
  { code: 'MC', ru: "Монако", en: "Monaco" },
  { code: 'MN', ru: "Монголия", en: "Mongolia" },
  { code: 'ME', ru: "Черногория", en: "Montenegro" },
  { code: 'MS', ru: "Монтсеррат", en: "Montserrat" },
  { code: 'MA', ru: "Марокко", en: "Morocco" },
  { code: 'MZ', ru: "Мозамбик", en: "Mozambique" },
  { code: 'MM', ru: "Мьянма", en: "Myanmar" },
  { code: 'NA', ru: "Намибия", en: "Namibia" },
  { code: 'NR', ru: "Науру", en: "Nauru" },
  { code: 'NP', ru: "Непал", en: "Nepal" },
  { code: 'NL', ru: "Нидерланды", en: "Netherlands" },
  { code: 'NC', ru: "Новая Каледония", en: "New Caledonia" },
  { code: 'NZ', ru: "Новая Зеландия", en: "New Zealand" },
  { code: 'NI', ru: "Никарагуа", en: "Nicaragua" },
  { code: 'NE', ru: "Нигер", en: "Niger" },
  { code: 'NG', ru: "Нигерия", en: "Nigeria" },
  { code: 'NU', ru: "Ниуэ", en: "Niue" },
  { code: 'NF', ru: "Остров Норфолк", en: "Norfolk Island" },
  { code: 'KP', ru: "КНДР (Корейская Народно-Демократическая Республика)", en: "North Korea" },
  { code: 'MP', ru: "Северные Марианские острова", en: "Northern Mariana Islands" },
  { code: 'NO', ru: "Норвегия", en: "Norway" },
  { code: 'OM', ru: "Оман", en: "Oman" },
  { code: 'PK', ru: "Пакистан", en: "Pakistan" },
  { code: 'PW', ru: "Палау", en: "Palau" },
  { code: 'PA', ru: "Панама", en: "Panama" },
  { code: 'PG', ru: "Папуа — Новая Гвинея", en: "Papua New Guinea" },
  { code: 'PY', ru: "Парагвай", en: "Paraguay" },
  { code: 'PH', ru: "Филиппины", en: "Philippines" },
  { code: 'PN', ru: "Острова Питкэрн", en: "Pitcairn Islands" },
  { code: 'PL', ru: "Польша", en: "Poland" },
  { code: 'PT', ru: "Португалия", en: "Portugal" },
  { code: 'PR', ru: "Пуэрто-Рико", en: "Puerto Rico" },
  { code: 'QA', ru: "Катар", en: "Qatar" },
  { code: 'XA', ru: "Республика Абхазия", en: "Republic of Abkhazia" },
  { code: 'CG', ru: "Республика Конго", en: "Republic of the Congo" },
  { code: 'GM', ru: "Гамбия", en: "Republic of The Gambia" },
  { code: 'RE', ru: "Реюньон", en: "Réunion" },
  { code: 'RO', ru: "Румыния", en: "Romania" },
  { code: 'RW', ru: "Руанда", en: "Rwanda" },
  { code: 'EH', ru: "Сахарская Арабская Демократическая Республика", en: "Sahrawi Arab Democratic Republic" },
  { code: 'BL', ru: "Сен-Бартелеми", en: "Saint Barthélemy" },
  { code: 'SH', ru: "Остров Святой Елены", en: "Saint Helena" },
  { code: 'KN', ru: "Сент-Китс и Невис", en: "Saint Kitts and Nevis" },
  { code: 'LC', ru: "Сент-Люсия", en: "Saint Lucia" },
  { code: 'MF', ru: "Сен-Мартен", en: "Saint Martin" },
  { code: 'PM', ru: "Сен-Пьер и Микелон", en: "Saint Pierre and Miquelon" },
  { code: 'VC', ru: "Сент-Винсент и Гренадины", en: "Saint Vincent and the Grenadines" },
  { code: 'WS', ru: "Самоа", en: "Samoa" },
  { code: 'SM', ru: "Сан-Марино", en: "San Marino" },
  { code: 'ST', ru: "Сан-Томе и Принсипи", en: "Sao Tome and Principe" },
  { code: 'SA', ru: "Саудовская Аравия", en: "Saudi Arabia" },
  { code: 'SN', ru: "Сенегал", en: "Senegal" },
  { code: 'RS', ru: "Сербия", en: "Serbia" },
  { code: 'SC', ru: "Сейшельские Острова", en: "Seychelles" },
  { code: 'SL', ru: "Сьерра-Леоне", en: "Sierra Leone" },
  { code: 'SG', ru: "Сингапур", en: "Singapore" },
  { code: 'SX', ru: "Синт-Мартен", en: "Sint Maarten" },
  { code: 'SK', ru: "Словакия", en: "Slovakia" },
  { code: 'SI', ru: "Словения", en: "Slovenia" },
  { code: 'SB', ru: "Соломоновы Острова", en: "Solomon Islands" },
  { code: 'SO', ru: "Сомали", en: "Somalia" },
  { code: 'ZA', ru: "ЮАР", en: "South Africa" },
  { code: 'GS', ru: "Южная Георгия и Южные Сандвичевы острова", en: "South Georgia and the South Sandwich Islands" },
  { code: 'KR', ru: "Республика Корея", en: "South Korea" },
  { code: 'XO', ru: "Южная Осетия", en: "South Ossetia" },
  { code: 'SS', ru: "Южный Судан", en: "South Sudan" },
  { code: 'LK', ru: "Шри-Ланка", en: "Sri Lanka" },
  { code: 'PS', ru: "Государство Палестина", en: "State of Palestine" },
  { code: 'SD', ru: "Судан", en: "Sudan" },
  { code: 'SR', ru: "Суринам", en: "Suriname" },
  { code: 'SJ', ru: "Шпицберген", en: "Svalbard" },
  { code: 'SE', ru: "Швеция", en: "Sweden" },
  { code: 'CH', ru: "Швейцария", en: "Switzerland" },
  { code: 'SY', ru: "Сирия", en: "Syrian Arab Republic" },
  { code: 'TW', ru: "Тайвань", en: "Taiwan" },
  { code: 'TJ', ru: "Таджикистан", en: "Tajikistan" },
  { code: 'MK', ru: "Северная Македония", en: "The Republic of North Macedonia" },
  { code: 'TL', ru: "Восточный Тимор", en: "Timor-Leste" },
  { code: 'TG', ru: "Того", en: "Togo" },
  { code: 'TK', ru: "Токелау", en: "Tokelau" },
  { code: 'TO', ru: "Тонга", en: "Tonga" },
  { code: 'TT', ru: "Тринидад и Тобаго", en: "Trinidad and Tobago" },
  { code: 'TN', ru: "Тунис", en: "Tunisia" },
  { code: 'TM', ru: "Туркмения", en: "Turkmenistan" },
  { code: 'TC', ru: "Острова Теркс и Кайкос", en: "Turks and Caicos Islands" },
  { code: 'TV', ru: "Тувалу", en: "Tuvalu" },
  { code: 'UG', ru: "Уганда", en: "Uganda" },
  { code: 'TZ', ru: "Танзания", en: "United Republic of Tanzania" },
  { code: 'VI', ru: "Виргинские острова США", en: "United States Virgin Islands" },
  { code: 'VU', ru: "Вануату", en: "Vanuatu" },
  { code: 'VA', ru: "Ватикан", en: "Vatican City" },
  { code: 'VE', ru: "Венесуэла", en: "Venezuela" },
  { code: 'VN', ru: "Вьетнам", en: "Vietnam" },
  { code: 'WF', ru: "Уоллис и Футуна", en: "Wallis and Futuna" },
  { code: 'YE', ru: "Йемен", en: "Yemen" },
  { code: 'ZM', ru: "Замбия", en: "Zambia" },
  { code: 'ZW', ru: "Зимбабве", en: "Zimbabwe" },
];

export function filterFlagCountries(query: string, lang = 'ru'): FlagCountry[] {
  const q = query.trim().toLowerCase();
  const list = FLAG_COUNTRIES;
  if (!q) return list;
  return list.filter(
    (c) =>
      c.code.toLowerCase().includes(q) ||
      c.ru.toLowerCase().includes(q) ||
      c.en.toLowerCase().includes(q),
  );
}
